<mat-card>
  <form [formGroup]="editAddressForm" class="uf-no-form">
    <mat-toolbar color="primary">
      <h1 class="mat-title">Adres</h1>
      <div>
        <label>standaard</label>
        <mat-slide-toggle formControlName="standard" matTooltip="Standaard adres"></mat-slide-toggle>
      </div>
    </mat-toolbar>
    <mat-card-content class="uf-form">
      <mat-form-field>
        <mat-label>Type</mat-label>
        <mat-select formControlName="typeId">
          @for (addresstype of addressTypes; track addresstype.id) {
            <mat-option [value]="addresstype.id">
              {{addresstype.name}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <div>
        <mat-form-field class="p-r-8">
          <mat-label>Postcode</mat-label>
          <input matInput type="text" formControlName="zip"/>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Nummer</mat-label>
          <input matInput type="text" formControlName="housenumber"/>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field class="p-r-8">
          <mat-label>Straat</mat-label>
          <input matInput type="text" formControlName="street"/>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Plaats</mat-label>
          <input matInput type="text" formControlName="city"/>
        </mat-form-field>
      </div>
      <mat-form-field>
        <mat-label>Land</mat-label>
        <mat-select formControlName="isoCountryId">
          @for (country of countries; track country.id) {
            <mat-option [value]="country.id">
              {{country.commonName}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </mat-card-content>
    <mat-card-actions>
      <button mat-button mat-raised-button (click)="onClose()">Annuleer</button>
      <button mat-button mat-raised-button color="primary" [disabled]="!editAddressForm.valid" (click)="onSave()">OK</button>
    </mat-card-actions>
  </form>
</mat-card>
